import React, { useEffect, useRef, useState } from 'react'
import StickyTable from '../../../../components/table/stickyTable/StickyTable';
import columnCreditGrants from './columnCreditGrants';
import { callApiWithoutDispatch } from '../../../../utils/apiUtils';
import { onBoardingGetFleetCreditGrantApi, onBoardingGetFleetTransactionsApi } from '../../../../constants/ApiConfigs';
import { Button } from 'react-bootstrap';
import {
  formatCurrencyHasSymbol,
  formatLongTypeToNumberCurrency,
} from '../../../../utils/commonFunctions';
import { I18n } from 'react-redux-i18n';
const BillingCreditGrants = ({
  billingUsage,
  ...props
}) => {
  const toobarContainerRef = useRef();
  const parentRef = useRef();
  const toolbarExtendRef = useRef();
  const [bodyData, setBodyData] = useState([]);
  const [footerData, setFooterData] = useState({
    limit: 20,
    total: 0,
    page: 0,
  });
  useEffect(() => {
    getBodyData();
  }, []);

  const getBodyData = async (activePage, limit) => {
    limit = limit ? limit : footerData.limit || 20;
    activePage = activePage ? activePage : footerData.page || 0;
    const response = await callApiWithoutDispatch(onBoardingGetFleetCreditGrantApi, {
      method: 'POST',
      body: JSON.stringify({
        fleetId: props.auth?.selectedFleet?.fleetId,
        limit: limit,
        page: activePage,
        search: '',
      })
    });
    if (response?.res?.list?.length > 0) {
      setBodyData(response.res.list);
      let { size, total } = response.res || {};
      setFooterData({
        ...footerData,
        total,
        limit,
        page: activePage,
      });
    } else {
      setBodyData([]);
      setFooterData({
        ...footerData,
        total: 0,
      });
    }
  }
  const getTableColumns = () => {
    let tableColums = Object.assign([], columnCreditGrants);

    _.forEach(tableColums, (col, index) => {
      switch (col.key) {
        case 'grantUsed':
          col.customCell = (data) => {
            return `${formatCurrencyHasSymbol(formatLongTypeToNumberCurrency(data.usedAmount, billingUsage?.currencyISO), billingUsage?.currencyISO)} / ${formatCurrencyHasSymbol(formatLongTypeToNumberCurrency(data.grantAmount, billingUsage?.currencyISO), billingUsage?.currencyISO)}`;
          }
          break;
        case 'status':
          col.customCell = (data) => {
            let isStatusActive = data.status === 'active' ? true : false;
            if(data.expiresAt * 1000 < Date.now()) {
              isStatusActive = false;
            }
            return <span className={isStatusActive ? 'statusCredit bg-success' : 'statusCredit bg-danger'}>
              {isStatusActive ? I18n.t('billingUsage.active') : I18n.t('billingUsage.expired')}
            </span>;
          }
      }
    });

    return tableColums;
  };

  const handleNumItemsPerPageChange = (limit) => {
    getBodyData(0, limit);
  }

  const handlePaginationSelect = (page) => {
    getBodyData(page, footerData.limit);
  }

  const getTableHeight = () => {
    const verticalPadding = 70;
    const toolbarheight = toobarContainerRef?.current?.offsetHeight || 0;
    const toolbarExtendHeight = toolbarExtendRef?.current?.offsetHeight || 0;
    const parentHeight = parentRef?.current?.offsetHeight || 0;
    const outerHeight = verticalPadding + toolbarheight + toolbarExtendHeight;
    let tableHeight = parentHeight ? parentHeight - outerHeight : 0;
    if (window.innerHeight < 850 && tableHeight < 500) tableHeight = 550;
    return tableHeight;
  };

  return (
    <div className="billing-credit-grants-container" ref={parentRef}>
        <StickyTable
          columns={getTableColumns()}
          bodyData={bodyData}
          footerData={footerData}
          rowHeight={50}
          getTableHeight={getTableHeight}
          handleNumItemsPerPageChange={handleNumItemsPerPageChange}
          handlePaginationSelect={handlePaginationSelect}
          notCheckShouldComponentUpdate={true}
        />
    </div>
  )
}

export default BillingCreditGrants